import { render, staticRenderFns } from "./AlertConnectionType.vue?vue&type=template&id=4680436f"
import script from "./AlertConnectionType.vue?vue&type=script&lang=js"
export * from "./AlertConnectionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports